import React from 'react';
import { Link } from 'react-router-dom';
import { PublicLayout } from '../../components/PublicLayout';
import { PublicPageSeo } from '../../components/PublicPageSeo';
import { RelatedLinks } from '../../components/RelatedLinks';
import { ClientDownloadCards } from '../../components/ClientDownloadCards';
import { getContent } from '../../content/i18n';
import { useLocale, useLocalizedPath } from '../../hooks/useLocale';
import { DevicePhoneMobileIcon } from '@heroicons/react/24/outline';

export const DownloadPage: React.FC = () => {
  const locale = useLocale();
  const localizedPath = useLocalizedPath();
  const content = getContent(locale);
  const { download } = content;
  const homePath = locale === 'en' ? '/en' : '/';
  const pagePath = locale === 'en' ? '/en/download' : '/download';

  return (
    <>
      <PublicPageSeo
        breadcrumbs={[
          { name: content.common.home, path: homePath },
          { name: download.title, path: pagePath },
        ]}
      />
      <PublicLayout
        breadcrumbs={[
          { label: content.common.home, href: localizedPath('/') },
          { label: download.title },
        ]}
      >
        <section className="py-12">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">{download.title}</h1>
          <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 max-w-3xl">{download.subtitle}</p>

          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            {locale === 'zh' ? 'NodeUnion 官方客户端' : 'NodeUnion Official Client'}
          </h2>
          <div className="mb-12">
            <ClientDownloadCards showMacQuarantineTip />
          </div>

          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">
            {locale === 'zh' ? '各平台配置指南' : 'Platform Setup Guides'}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {download.platforms.map((platform) => (
              <Link
                key={platform.id}
                to={localizedPath(`/download/${platform.id}`)}
                className="p-6 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 hover:border-primary-500 transition-colors"
              >
                <DevicePhoneMobileIcon className="h-10 w-10 text-primary-600 dark:text-primary-400 mb-4" />
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{platform.name}</h2>
                <p className="text-sm text-gray-600 dark:text-gray-300">{platform.description}</p>
              </Link>
            ))}
          </div>
        </section>

        <RelatedLinks
          links={[
            { label: locale === 'zh' ? 'TikTok 运营指南' : 'TikTok Guide', href: '/help' },
            { label: locale === 'zh' ? '使用教程' : 'Help Center', href: '/help' },
            { label: locale === 'zh' ? '套餐价格' : 'Pricing', href: '/pricing' },
          ]}
        />
      </PublicLayout>
    </>
  );
};
